<script>
import ArticleApi from "@shared/_api/article";
import {mapActions, mapGetters, mapState} from "vuex";
import {config} from "@shared/_services/config";
import CategoryApi from "@shared/_api/category";
import {HTTP} from "@shared/_helpers/http";

export default {
   data() {
      return {
         selectedSize: null,
         selectedColor: null,
         busy: false,
         busyAddingSample: false,
         colorSelectCustomerMode: false,
         loadingExport: false,
         loadingExportCsv: false,
         loadingVariantList: false,
         variantListLoaded: false,
         loadingPrice: false,
         loadingArticleStub: false,
         loadingArticleCategory: false,
         cardId: null,
         baseUrl: config.baseUrl + config.resourceUrl,
         loadingGtlArticle: false
      }
   },
   methods: {
      ...mapActions("cart", ["fetchCart"]),
      ...mapActions('sample', ['addSample', 'fetchSampleList']),
      ...mapActions('favorites', ['removeFavorite']),
      selectVariant: function (colorId, sizeId) {
         this.selectedColor = Number(colorId);
         this.selectedSize = Number(sizeId);
      },
      toggleColorSelectMode: function () {
         this.colorSelectCustomerMode = !this.colorSelectCustomerMode
      },
      getThumbnail(sizeIdParam, colorIdParam) {

         if (this.articleDetails && this.articleDetails.articleImageList) {
            let variantImages = this.articleDetails.articleImageList.filter(img => {
               let sizeId = Number(img.sizeId),
                   colorId = Number(img.colorId);

               if (sizeId && sizeIdParam) {
                  return (colorId === colorIdParam || (sizeId === sizeIdParam && colorId === colorIdParam))
               } else if (colorIdParam) {
                  return (colorId === colorIdParam)
               } else if (sizeIdParam) {
                  return (sizeId === sizeIdParam)
               }
            });


            if (variantImages.length > 0) {
               return variantImages[0];
            }

            let defaultImageList = this.articleDetails.articleImageList.filter(i => Number(i.colorId) === 0 && Number(i.sizeId) === 0);

            if (defaultImageList.length > 0) {
               return defaultImageList[0];
            }
         }

         return null;
      },
      loadVariantPrice() {
         if (this.selectedVariant && this.user) {

            // check if price is already loaded
            if (this.selectedVariant && !this.selectedVariant.articlePrice) {

               this.loadingPrice = true;

               return ArticleApi.articlePrice(this.articleDetails.id, this.selectedVariant.variationId, (this.category) ? this.category.id : null).then(price => {
                  this.selectedVariant.articlePrice = price;
               }).finally(() => {
                  this.loadingPrice = false;
               });
            }
         }
      },
      loadGtlArticle() {
         if (this.selectedVariant && this.user) {
            this.loadingGtlArticle = true;
            HTTP.get(`/public/gtl/article/${this.selectedVariant.variationId}/${this.article.id}/${this.selectedVariant.articleColor.id}/${this.selectedVariant.articleSize.id}`)
                .then(response => {
                   this.selectedVariant.gtlArticle = response.data;
                }).finally(() => {
               this.loadingGtlArticle = false;
            });
         }
      },
      loadArticleStub(articleId, categoryId) {
         let apiFunctionArticle = this.user ? ArticleApi.customerArticleStubById : ArticleApi.articleStubById;

         this.loadingArticleStub = true;

         return apiFunctionArticle(articleId, categoryId).then(article => {
            this.article = article;
            return article;
         }).finally(() => {
            this.loadingArticleStub = false;
         });
      },
      loadArticleCategory(categoryId) {
         let apiFunctionCategory = this.user ? CategoryApi.customerCategoryById : CategoryApi.byId;

         this.loadingArticleCategory = true;

         return apiFunctionCategory(categoryId).then(category => {
            this.category = category;
            return category;
         }).finally(() => {
            this.loadingArticleCategory = false;
         });
      },
      loadArticleVariantList(articleId, categoryId) {
         let apiFunctionArticle = this.user ? ArticleApi.customerArticlebyId : ArticleApi.byId;
         this.loadingVariantList = true;
         return apiFunctionArticle(articleId, categoryId).then(article => {
            let result = [],
                map = new Map();

            for (const variant of article.variantList) {
               let variantId = variant.variationId;

               if (!map.has(variantId)) {
                  map.set(variantId, true);
                  result[variantId] = variant.articlePrice
               }
            }

            for (const variant of this.variantList) {
               variant.articlePrice = result[variant.variationId];
            }

         }).finally(() => {
            this.loadingVariantList = false;
            this.variantListLoaded = true;
         })
      },
      onAddToSamples() {
         let selectedVariant = this.selectedVariant;

         if (selectedVariant) {

            this.busyAddingSample = true;
            this.addSample({
               item: {
                  "articleId": this.article.id,
                  "categoryId": this.category.id,
                  "variantId": selectedVariant.variationId,
                  "amount": 1,
                  "cardId": (this.colorId && this.cardId && selectedVariant.articleColor.id == this.colorId) ? this.cardId : null
               }
            }).then(() => {
               this.$bvToast.toast(`Successfully added the item to your sample request.`, this.$toastSuccess);
               this.fetchSampleList();
            }).catch((error) => {
               if (error && error.status === 400) {
                  this.$bvToast.toast(`Item was already added.`, this.$toastDanger);
               } else {
                  this.$bvToast.toast(`Error adding item to your sample request.`, this.$toastDanger);
               }

            }).finally(() => {
               this.busyAddingSample = false;
            });
         }
      },
      addToFavorites() {
         let selectedVariant = this.selectedVariant;

         if (this.isInFavorites) {
            this.removeFavorite({
               id: this.article.id
            }).then(() => {
               this.$bvToast.toast(`Successfully removed from favorites.`, this.$toastSuccess);
            }).catch(() => {
               this.$bvToast.toast(`Error removing article from favorites.`, this.$toastDanger);
            })
         } else {
            if (selectedVariant) {
               this.addFavorite({
                  favoriteItem: {
                     "articleId": this.article.id,
                     "categoryId": this.category.id,
                     "variantId": selectedVariant.variationId
                  }
               }).then(() => {
                  this.$bvToast.toast(`Successfully added the item to favorites.`, this.$toastSuccess);
               }).catch(() => {
                  this.$bvToast.toast(`Error adding item to your favorites.`, this.$toastDanger);
               })
            }
         }


      },
      onAddToCart() {
         let selectedVariant = this.selectedVariant;

         if (this.itemArray && Object.values(this.itemArray).find(item => Number(item.variantId) === Number(selectedVariant.variationId))) {
            this.$bvToast.toast(`Item was already added to basket.`, this.$toastDanger);
            return;
         }

         if (selectedVariant) {
            this.$validator.validate().then(valid => {

               if (valid || (!this.isBasicShop && this.amount > 0)) {
                  this.submitProcessing = true;
                  let validAmount = false;
                  if (this.articlePrice) {
                     let minValueRule = [this.sampleThreshold];
                     let isGapped = (this.articlePrice.calculatedStock > 0 && this.articlePrice.calculatedStock > this.sampleThreshold && this.articlePrice.calculatedStock < this.articleDetails.sampleThreshold);
                     validAmount = isGapped ? (Number(this.sampleThreshold) <= this.amount && Number(this.articlePrice.calculatedStock) >= this.amount) || (Number(this.articleDetails.sampleThreshold) <= this.amount) : this.amount >= Math.max(1, minValueRule);
                  }

                  return this.addItem({
                     cartItem: {
                        "articleId": this.article.id,
                        "categoryId": this.category.id,
                        "variantId": selectedVariant.variationId,
                        "amount": this.amount,
                        "sessionId": window.$cookies.get("sessionId"),
                        "total": this.total,
                        "requestedAmountState": (!validAmount && (!this.isBasicShop && this.amount > 0)) ? "RESERVED" : "AVAILABLE"
                     }
                  }).then(() => {
                     this.amount = null;
                     this.$validator.reset().finally(() => {
                        this.submitProcessing = false;
                        this.$bvToast.toast(`Item successfully added.`, this.$toastSuccess);
                     });
                     this.fetchCart();
                  })
               }
               return Promise.resolve();
            }).finally(() => {
               this.busy = false;
            });
         }
      },
      loadArticlePdf() {
         this.loadingExport = true;

         ArticleApi.customerArticlePdf(this.article.id, this.selectedColor, (this.category && this.category.id ? this.category.id : null)).then(res => {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.article.name + '.pdf');
            document.body.appendChild(link);
            link.click();
         }).finally(() => {
            this.loadingExport = false;
            if (this.selectedColor) {
               this.trackPdfDownload(this.article.name, this.colorOptions
                   .find(opt => opt.value === this.selectedColor)
                   .text);
            } else {
               this.colorOptions.forEach(color => {
                  this.trackPdfDownload(this.article.name, color.text);
               })
            }

         });
      },
      trackPdfDownload(articleName, colorName) {
         this.$tracker.trackEvent({
            label: 'download',
            meta: articleName + "|" + colorName,
            type: 'DOWNLOAD_ARTICLE_DETAILS_PDF'
         });
      },
      loadArticleCsv() {
         this.loadingExportCsv = true;
         ArticleApi.customerArticleCsv(this.article.id, (this.category.id ? this.category.id : null)).then(res => {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.article.name + '.csv');
            document.body.appendChild(link);
            link.click();
         }).finally(() => {
            this.loadingExportCsv = false;
            this.$tracker.trackEvent({
               label: 'download',
               meta: this.article.name,
               type: 'DOWNLOAD_ARTICLE_DETAILS_CSV'
            });
         })
      },
   },
   computed: {
      ...mapState("account", ['user']),
      ...mapState("favorites", ['loadingFavorites']),
      ...mapGetters('cart', ['itemArray']),
      ...mapGetters('favorites', ['favorites']),
      ...mapGetters('account', ['hasRole', 'canRead']),
      ...mapGetters('sample', ['sampleItemList']),
      showForeignCurrency() {
         return this.user && this.user.externalAccountType === 'DIAMOND' && this.user.pricingInAllCurrencies && (this.articlePrice.samplePriceForeignCurrency > 0 || this.articlePrice.priceForeignCurrency > 0);
      },
      imageList: function () {
         let defaultImageList = this.defaultImages.concat(this.article.cardImg && this.user ? [{media: this.article.cardImg}] : []);
         let defaultIndex = (this.variantImages && this.variantImages.length > 0) ? defaultImageList.length : 0;
         return defaultImageList.concat(this.variantImages).map((img, index) => {
            return {
               src: this.articleImageResource(img.media, 1000),
               isDefault: index === Number(defaultIndex),
               name: img.media
            };
         });
      },
      variantImages: function () {
         if (this.article && this.article.articleImageList) {
            return this.article.articleImageList.filter(img => {
               let sizeId = Number(img.sizeId),
                   colorId = Number(img.colorId);

               if (sizeId && colorId) {
                  return (colorId === this.selectedColor || (sizeId === this.selectedSize && colorId === this.selectedColor));
               }

               if (this.selectedColor && this.selectedSize) {
                  // if both color and size are set, both have to match or only color
                  if (this.isNotZeroAndEmpty(sizeId) && this.isNotZeroAndEmpty(colorId)) {
                     return (colorId === this.selectedColor || (sizeId === this.selectedSize && colorId === this.selectedColor));
                  }

                  // otherwise when sizeId isset match sizeId or if colorId isset, match coloId
                  return this.isNotZeroAndEmpty(sizeId) ? sizeId === this.selectedSize : colorId === this.selectedColor;
               } else if (this.selectedColor) {
                  return (colorId === this.selectedColor)
               } else if (this.selectedSize) {
                  return (sizeId === this.selectedSize)
               }
            });
         }
         return [];
      },
      defaultImages: function () {
         let defaultImages = this.article && this.article.articleImageList ? this.article.articleImageList.filter(i => Number(i.colorId) === 0 && Number(i.sizeId) === 0) : [];

         if (defaultImages.length === 0 && (this.article.webImage || this.article.image)) {
            defaultImages.push({media: this.article.webImage || this.article.image});
         }

         return defaultImages;
      },
      showSelectCustomerModeSwitch() {
         if (this.variantList && this.variantList.length > 0) {
            let itemsWithOnlyCustomerValues = this.variantList.some(variant => variant.articleColor.customerValue);
            let asd = this.variantList.some(variant => !variant.articleColor.customerValue);

            return itemsWithOnlyCustomerValues && asd;
         }
         return false;
      },
      inSampleList() {
         if (this.selectedVariant && this.sampleItemList) {
            return Object.values(this.sampleItemList).some(value => value.variantId === this.selectedVariant.variationId);
         }
         return false;
      },
      contactSubject: function () {

         let subjectArr = [];
         if (this.category) {
            subjectArr.push(this.category.webName || this.category.name);
         }

         subjectArr.push(`${this.user.firstName} ${this.user.lastName} ${this.user.externalData.company.companyName}`);
         subjectArr.push(this.article.name);

         if (this.selectedColor) {
            subjectArr.push(this.variantList.find(variant => variant.articleColor.id === this.selectedColor).articleColor.value);
         }

         return subjectArr.join(" | ");
      },
      isInFavorites: function () {
         return this.favorites.find(fav => {
            return fav.articleId == this.article.id;
         })
      },
      isApproved: function () {
         return this.article.passApproval;
      },
      fileList: function () {
         return this.articleDetails ? this.articleDetails.articleFileList : [];
      },
      variantList: function () {
         return this.articleDetails ? this.articleDetails.variantList : [];
      },
      link3D: function () {
         return (this.article && config.mock3d[this.article.id]) ? config.mock3d[this.article.id] : null;
      },
      isPurchaseLocked: function () {
         return !this.selectedVariant || (this.isBasicShop && !this.validateState('amount')) || (this.articlePrice && this.articlePrice.samplePrice <= 0.0 && this.articlePrice.price <= 0.0) || (!this.user || !this.user.externalData);
      },
      amountValidationRule: function () {
         return {
            required: true
         };
      },
      pricePerUnit: function () {
         if (this.amount && this.amount >= this.sampleThreshold && this.articlePrice) {
            return (this.amount < this.articleDetails.bulkpriceThreshold) ? this.articlePrice.samplePricePerUnit : this.articlePrice.pricePerUnit
         }
         return null;
      },
      isBasicShop() {
         return (this.category && (Number(this.category.customerId) === 0))
      },
      isDiscountOnStockActive() {
         if (this.articlePrice && this.amount > 0) {
            return (this.amount < this.articleDetails.bulkpriceThreshold) && this.isBasicShop && this.articlePrice.calculatedStock > 0;
         }
         return false;
      },
      isSamplePrice() {
         if (this.articlePrice && this.amount > 0) {
            return (this.amount < this.articleDetails.bulkpriceThreshold);
         }
         return false;
      },
      total: function () {
         if (this.articlePrice && this.amount > 0) {
            let reducedAmount = Math.min(this.articlePrice.calculatedStock, this.amount),
                regularAmount = this.amount - reducedAmount;

            if (this.amount < this.articleDetails.bulkpriceThreshold) {
               return this.isBasicShop ? (this.articlePrice.samplePricePerUnit * regularAmount) + (reducedAmount * this.articlePrice.pricePerUnitOnStock) : (this.articlePrice.samplePricePerUnit * this.amount)
            }
            return this.amount * this.articlePrice.pricePerUnit
         }
         return null;
      },
      sampleThreshold: function () {
         if (this.articleDetails && this.articlePrice) {
            return (this.articlePrice) ? this.articlePrice.adjustedSampleThreshold : this.articleDetails.sampleThreshold;
         }
         return null;
      },
      customerArticleNumber: function () {
         let articleNameCustomer = this.article.articleNameCustomer,
             articleNameUser = this.article.articleNameUser;

         if (this.isBasicShop) {
            if (articleNameUser && this.user) {
               return `Internal No. ${articleNameUser}`;
            }
         } else if (articleNameCustomer && this.category) {
            return `${this.category.webName} No. ${articleNameCustomer}`;
         }

         return null;
      },
      sizeOptions: function () {
         let result = [],
             map = new Map();

         for (const item of this.variantList) {
            let articleSizeId = item.articleSize.id,
                articleColorId = item.articleColor.id;

            if (!map.has(articleSizeId) && (!this.selectedColor || this.selectedColor === articleColorId)) {
               map.set(articleSizeId, true);
               let customValue = item.articleSize.customerValue || item.articleSize.userValue;
               let label = item.articleSize.value + (customValue ? ` (${customValue})` : '');
               result.push({
                  customerValue: customValue,
                  diamondValue: item.articleSize.value,
                  value: articleSizeId,
                  text: label,
                  nos: item.neverOutOfStockSize
               });
            }
         }
         return result;
      },
      colorOptions: function () {
         const result = [];
         const map = new Map();
         let articleVariantList;

         if (this.colorSelectCustomerMode) {
            articleVariantList = this.variantList.filter(variant => variant.articleColor.customerValue);
         }

         if (!articleVariantList) {
            articleVariantList = this.variantList;
         }

         for (const item of articleVariantList) {
            let articleSizeId = item.articleSize.id,
                articleColorId = item.articleColor.id;

            if (!map.has(articleColorId) && (!this.selectedSize || this.selectedSize === articleSizeId)) {
               map.set(articleColorId, true);
               let customValue = item.articleColor.customerValue || item.articleColor.userValue;
               let label = item.articleColor.value + (customValue ? ` (${customValue})` : '');
               let thumbnail = this.article.articleImageList ? this.article.articleImageList.find(i => i.colorId === articleColorId) : null

               result.push({
                  value: articleColorId,
                  text: label,
                  customerValue: customValue,
                  diamondValue: item.articleColor.value,
                  thumbnail: thumbnail ? thumbnail.media : null,
                  nos: item.neverOutOfStock
               });
            }
         }

         result.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));

         return result;
      },
      colorSizeMatrix: function () {
         let result = [],
             images = this.article.articleImageList;

         if (this.variantList.some((item) => !item.articlePrice)) {
            return result;
         }

         for (let i = 0; i < this.variantList.length; i++) {


            let variation = this.variantList[i];
            if (!result[variation.articleColor.id]) {
               let customValueColor = variation.articleColor.customerValue || variation.articleColor.userValue;
               let labelColor = variation.articleColor.value + (customValueColor ? ` (${customValueColor})` : '');
               let thumbnail = images ? images.find(i => i.colorId === variation.articleColor.id) : null;

               result[variation.articleColor.id] = {
                  id: variation.articleColor.id,
                  thumbnail: thumbnail ? thumbnail.media : null,
                  color: labelColor,
                  sizeOptions: []
               };
            }

            let customValueSize = variation.articleSize.customerValue || variation.articleSize.userValue;
            let labelSize = variation.articleSize.value + (customValueSize ? ` (${customValueSize})` : '');

            result[variation.articleColor.id].sizeOptions.push({
               id: variation.articleSize.id,
               label: labelSize,
               stock: variation.articlePrice.calculatedStock,
               nos: variation.neverOutOfStock && variation.neverOutOfStockSize
            })

         }

         result.sort((a, b) => (a.color > b.color) ? 1 : ((b.color > a.color) ? -1 : 0));

         return result;
      },
      articlePrice: function () {
         return this.selectedVariant && this.selectedVariant.articlePrice ? this.selectedVariant.articlePrice : null;
      },
      gtlArticle: function () {
         return this.selectedVariant ? this.selectedVariant.gtlArticle : null;
      },
      selectedVariant: function () {
         return this.variantList.find(articleVariation => {
            return (Number(articleVariation.articleSize.id) === Number(this.selectedSize)) && (Number(articleVariation.articleColor.id) === Number(this.selectedColor));
         })
      }
   },
   watch: {
      selectedColor(newColorId) {
         if (this.colorSelectCustomerMode) {
            let variant = this.variantList.some(variant => variant.articleColor.id === newColorId && variant.articleColor.customerValue);

            if (!variant) {
               this.colorSelectCustomerMode = false;
            }
         }
      }
   }
}
</script>